import {
  getDriveTourComplete,
  getSortTourComplete,
  setDriveTourComplete,
  setSortTourComplete
} from "../localStorage";

const tours = {
  state: {
    drive: false,
    driveComplete: getDriveTourComplete(),
    sort: false,
    sortComplete: getSortTourComplete()
  },

  mutations: {
    setDriveTour(state, enabled) {
      state.drive = enabled;
    },

    setSortTour(state, enabled) {
      state.sort = enabled;
    }
  },

  actions: {
    hideDriveTour({ commit }) {
      setDriveTourComplete(true);
      commit("setDriveTour", false);
    },

    showDriveTour({ commit }) {
      commit("setDriveTour", true);
    },

    hideSortTour({ commit }) {
      setSortTourComplete(true);
      commit("setSortTour", false);
    },

    showSortTour({ commit }) {
      commit("setSortTour", true);
    }
  }
};

export default tours;
